import { ThemeProvider } from "@mui/material/styles";
import { initializeApp } from "firebase/app";
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { v4 as uuid } from "uuid";

import NotFound from "./404/NotFound";
import { AuthProvider } from "./AuthProvider";
import AiExercise from "./exercise/AiExercise";
import AiExerciseSession from "./exercise/AiExerciseSession";
import ExercisesTable from "./exercise/ExecercisesTable";
import ExerciseForm from "./exercise/ExerciseForm";
import TraditionalExercise from "./exercise/TraditionalExercise";
import { ExerciseSessionProvider } from "./ExerciseSessionProvider";
import Home from "./home/Home";
import Imprint from "./imprint/Imprint";
import { useLogging } from "./logging/useLogging";
import Login from "./login/Login";
import MasterLayout from "./master/MasterLayout";
import { pages } from "./pages/pages";
import Profile from "./profile/Profile";
import Setting from "./profile/Setting";
import Session from "./session/Session";
import theme from "./styles/theme";
import SimpleSummary from "./summary/SimpleSummary";
import Summary from "./summary/Summary";
import { AppEvent } from "./types";
import { firebaseConfig } from "./utils/firebase.config";

function App() {
    localStorage.removeItem("activeSession");

    initializeApp(firebaseConfig);

    const { logWithPayload, log } = useLogging();
    const location = useLocation();

    useEffect(() => {
        logWithPayload(AppEvent.PathChanged, { path: location.pathname });
        // logWithPayload will never change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        if (!localStorage.getItem("userId")) {
            localStorage.setItem("userId", uuid());
        }
        if (!sessionStorage.getItem("tabId")) {
            sessionStorage.setItem("tabId", uuid());
            log(AppEvent.TabSessionStarted);
        }
        logWithPayload(AppEvent.AppLoaded, { path: window.location.pathname });
        window.addEventListener("beforeunload", () => {
            log(AppEvent.AppUnloaded);
        });
        // logWithPayload will never change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AuthProvider>
            <ThemeProvider theme={theme}>
                <ExerciseSessionProvider>
                    <Routes>
                        <Route element={<MasterLayout />}>
                            <Route path={pages.home} element={<Home />} />
                            <Route path={pages.exercise} element={<TraditionalExercise />} />
                            <Route path={pages.ai_exercise} element={<AiExercise />} />
                            <Route path={pages.ai_exercise_session} element={<AiExerciseSession />} />
                            <Route path={pages.summary} element={<Summary />} />
                            <Route path={pages.simple_summary} element={<SimpleSummary />} />
                            <Route path={pages.profile} element={<Profile />} />
                            <Route path={pages.exercise_list} element={<ExercisesTable />} />
                            <Route path={pages.exercise_edit} element={<ExerciseForm />} />
                            <Route path={pages.session} element={<Session />} />
                            <Route path={pages.setting} element={<Setting />} />
                            <Route path={pages.imprint} element={<Imprint />} />
                            <Route path={pages.login} element={<Login />} />

                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </ExerciseSessionProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;
